'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 49
// module chunks = 21571696733600 35783957827783 278999228825771